<template>
  <div class="profile-box">
    <div class="profile-title">
      Basic information
      <span style="color: #f48c06">{{
        userInfo.status === -1 ? "(wait for reviewing)" : ""
      }}</span>
    </div>

    <el-form ref="groupForm" class="profile-box_container" :model="groupForm">
      <div class="left">
        <el-form-item class="profile-avatar-box">
          <el-upload
            v-loading="loadingAvatar"
            :on-preview="handlePreview"
            :headers="{ 'x-covey-token': xToken }"
            :before-upload="(file) => beforeAvatarUpload(file, 4)"
            :accept="imgRules"
            :show-file-list="false"
            :data="{ ts: Date.now() }"
            :on-exceed="handleAvatarExceed"
            :on-success="(res) => handleUploadSuccess(res, 4)"
            :action="getUploadImg + '?ts=' + Date.now()"
          >
            <img
              class="my-info-avatar"
              :src="groupForm.photo || defaultAvatar"
            />
            <span
              class="upload-info"
              v-if="!groupForm.photo"
              style="margin-right: 8px"
              >Upload a new photo</span
            >
            <img
              v-if="!groupForm.photo"
              :src="require('@/assets/icon/upload.png')"
            />
          </el-upload>
        </el-form-item>
        <el-form-item label="Club Description">
          <el-input
            type="textarea"
            :rows="6"
            placeholder="Enter personal profile"
            v-model="groupForm.desc"
          ></el-input>
        </el-form-item>

        <el-form-item label="Society name" prop="societyName">
          <el-input
            v-model="groupForm.societyName"
            placeholder="Official name registered at the school"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="Association official website URL"
          prop="officalURL"
        >
          <el-input
            v-model.trim="groupForm.officalURL"
            placeholder="Association official website URL"
          ></el-input>
        </el-form-item>

        <div class="inline-upload">
          <el-form-item label="Club Image">
            <el-upload
              class="item-upload"
              v-loading="loadingGroupImg"
              :on-preview="handlePreview"
              :accept="imgRules"
              :show-file-list="false"
              :headers="{ 'x-covey-token': xToken }"
              :on-exceed="handleAvatarExceed"
              :before-upload="(file) => beforeAvatarUpload(file, 5)"
              :on-success="(res) => handleUploadSuccess(res, 5)"
              :on-error="handleUploadError"
              :action="getUploadImg + '?ts=' + Date.now()"
            >
              <div
                class="upload-icon"
                :style="{
                  'background-image': 'url(' + groupForm.groupImg + ')',
                  'border-color': groupForm.groupImg
                    ? 'transparent'
                    : '#DCDFE6',
                }"
              >
                <i v-if="!groupForm.groupImg" class="el-icon-circle-plus"></i>
                <span v-if="!groupForm.groupImg">Add Images</span>
              </div>
            </el-upload>
          </el-form-item>

          <el-form-item
            label="Official registration record"
            prop="registerRecord"
          >
            <el-upload
              class="item-upload"
              v-loading="loadingRecordImg"
              :show-file-list="false"
              :on-exceed="handleExceed"
              :before-upload="(file) => beforeAvatarUpload(file, 1)"
              :on-success="(res) => handleUploadSuccess(res, 1)"
              :on-error="handleUploadError"
              :action="getUploadImg + '?ts=' + Date.now()"
            >
              <div
                class="upload-icon"
                :style="{
                  'background-image': 'url(' + groupForm.registerRecord + ')',
                  'border-color': groupForm.registerRecord
                    ? 'transparent'
                    : '#DCDFE6',
                }"
              >
                <i
                  v-if="!groupForm.registerRecord"
                  class="el-icon-circle-plus"
                ></i>
                <span v-if="!groupForm.registerRecord">Add Images</span>
              </div>
            </el-upload>
          </el-form-item>
        </div>
      </div>
      <div style="width: 32px"></div>
      <div class="right">
        <el-form-item label="Applicant name" prop="applicantName">
          <el-input
            v-model="groupForm.applicantName"
            placeholder="Applicant name"
          ></el-input>
        </el-form-item>
        <el-form-item label="Applicant job title" prop="applicantJobTitle">
          <el-input
            v-model="groupForm.applicantJobTitle"
            placeholder="Applicant job title"
          ></el-input>
        </el-form-item>

        <div class="inline-upload">
          <el-form-item
            class="uploader-box"
            prop="studentIDImg"
            label="Student ID photo"
          >
            <el-upload
              class="item-upload"
              v-loading="loadingIDImg"
              :show-file-list="false"
              :on-exceed="handleExceed"
              :before-upload="(file) => beforeAvatarUpload(file, 2)"
              :on-success="(res) => handleUploadSuccess(res, 2)"
              :on-error="handleUploadError"
              :action="getUploadImg + '?ts=' + Date.now()"
            >
              <div
                class="upload-icon"
                :style="{
                  'background-image': 'url(' + groupForm.studentIDImg + ')',
                  'border-color': groupForm.studentIDImg
                    ? 'transparent'
                    : '#DCDFE6',
                }"
              >
                <i
                  v-if="!groupForm.studentIDImg"
                  class="el-icon-circle-plus"
                ></i>
                <span v-if="!groupForm.studentIDImg">Add Images</span>
              </div>
            </el-upload>
          </el-form-item>

          <el-form-item
            class="uploader-box"
            prop="studentIDImg"
            label="ID photo"
          >
            <el-upload
              class="item-upload"
              v-loading="loadingPhotoIDImg"
              :show-file-list="false"
              :on-exceed="handleExceed"
              :before-upload="(file) => beforeAvatarUpload(file, 3)"
              :on-success="(res) => handleUploadSuccess(res, 3)"
              :on-error="handleUploadError"
              :action="getUploadImg + '?ts=' + Date.now()"
            >
              <div
                class="upload-icon"
                :style="{
                  'background-image': 'url(' + groupForm.photoIDImg + ')',
                  'border-color': groupForm.photoIDImg
                    ? 'transparent'
                    : '#DCDFE6',
                }"
              >
                <i v-if="!groupForm.photoIDImg" class="el-icon-circle-plus"></i>
                <span v-if="!groupForm.photoIDImg">Add Images</span>
              </div>
            </el-upload>
          </el-form-item>
        </div>
      </div>
    </el-form>

    <div class="profile-item" style="text-align: center">
      <el-button
        class="my-button"
        @click.native="preserveGeneralInformation"
        :loading="saveLoading"
        >Save</el-button
      >
    </div>
    <el-dialog :visible.sync="previewImgDialog" :show-close="true">
      <img style="width: 100%; height: auto" :src="previewImgUrl" />
    </el-dialog>
  </div>
</template>

<script>
import { MD5, scopeDomain } from "@/utils/comm";
import ValidateButton from "@/views/Mobile/Component/ValidateButton";
import { mapState, mapGetters } from "vuex";
export default {
  components: {
    ValidateButton,
  },
  created() {},
  watch: {
    userInfo: function (newval, oldVal) {
      this.initUserinfo();
    },
  },
  computed: {
    ...mapState({
      xToken: (state) => state.app.token,
      userInfo: (state) => state.app.userInfo,
      defaultAvatar: (state) => state.app.defaultAvatar,
    }),
    ...mapGetters(["getUploadImg"]),
  },
  mounted() {
    this.$nextTick(() => {
      this.initUserinfo();
    });
    this.getGroupInfo();
  },
  data() {
    return {
      loading: true,
      imgRules: "image/png , image/jpeg",

      realNameLoading: false, //更新RealName等待
      previewImgDialog: false,
      previewImgUrl: "",
      saveLoading: false,
      groupForm: {
        photo: "",
        desc: "",
        groupImg: "",
        id: "",
        groupId: "",
      },
      loadingPhotoIDImg: false,
      loadingIDImg: false,
      loadingRecordImg: false,
      loadingPhotoIDImg: false,

      loadingGroupImg: false, //社团相册
      loadingAvatar: false,
    };
  },
  methods: {
    initUserinfo() {
      this.groupForm.photo = this.userInfo.photo || "";
      this.groupForm.desc = this.userInfo.desc || "";
      this.groupForm.groupImg = this.userInfo.groupImg || "";
      this.groupForm.groupId = this.userInfo.groupId;
      this.groupForm.id = this.userInfo.id;

      this.loading = false;
    },

    getGroupInfo() {
      this.$api.groupApi
        .getgroupinfo({ groupId: this.userInfo.groupId })
        .then((res) => {
          if (res.status === "0") {
            let t = res.data;
            let p = {
              societyName: t.societyName,
              maincontent: t.maincontent,
              officalURL: t.officalURL,
              registerRecord: t.registerRecord,
              applicantName: t.applicantName,
              applicantJobTitle: t.applicantJobTitle,
              studentIDImg: t.studentIDImg,
              photoIDImg: t.photoIDImg,
            };
            this.groupForm = Object.assign({}, p, this.groupForm);
          }
        });
    },
    handleAvatarExceed() {
      this.$message.error("Up to a photo can be uploaded.");
    },
    handlePreview(file) {
      this.previewImgDialog = true;
      this.previewImgUrl = file.url;
    },

    handleExceed(files, fileList) {
      this.$message.error("Only one picture can be uploaded!");
    },
    handleImgSuccess(res, file, fileList) {
      //社团头像
      if (res.status === "0") {
        this.$message.success("SUCCESS!");
        this.groupForm.photo = res.data;
      } else {
        this.$message.error(`${file.name} ERROR! Reason : ${res.message}`);
      }
      this.loadingImg = false;
    },
    handleGallerySuccess(res, file, fileList) {
      //社团的活动图
      if (res.status === "0") {
        this.$message.success("SUCCESS!");
        this.groupForm.groupImg = res.data;
      } else {
        this.$message.error(`${file.name} ERROR! Reason : ${res.message}`);
      }
      this.loadingImg = false;
    },
    preserveGeneralInformation() {
      this.$confirm(
        "Is it really modified and will be re-examined after modification?",
        "Prompt",
        {
          type: "warning",
        }
      )
        .then(() => {
          let params = { ...this.groupForm };
          this.saveLoading = true;
          this.$api.groupApi.updategroupinfo(params).then((res) => {
            //更新个人信息之后要重新接收 信息
            if (res.status === "0") {
              this.$store.dispatch("REFRESH_USER_INFO");
              this.getGroupInfo();
              this.$message.success("SUCCESS!");
            } else {
              this.$message.error(`ERROR! Reason : ${res.message}`);
            }
            this.saveLoading = false;
          });
        })
        .catch(() => {});
    },

    handleUploadError(err, file, fileList) {
      if (err) {
        this.$message.error(
          "There was an error uploading the image, please try again later！"
        );
      }
    },

    beforeAvatarUpload(file, type) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (!isJPG && !isPNG) {
        this.$message.error(
          "The uploaded avatar image can only be in JPG or PNG format!"
        );

        return false;
      }
      if (!isLt20M) {
        this.$message.error(
          "The size of the uploaded avatar image cannot exceed 20MB!"
        );
        return false;
      }
      if (type === 1) {
        this.loadingRecordImg = true;
      } else if (type === 2) {
        this.loadingIDImg = true;
      } else if (type === 3) {
        this.loadingPhotoIDImg = true;
      }

      if (type === 4) {
        //社团头像

        this.loadingAvatar = true;
      }
      if (type === 5) {
        //社团相册

        this.loadingGroupImg = true;
      }
      return (isJPG || isPNG) && isLt20M;
    },

    async handleUploadSuccess(res, type) {
      //获取上传图片地址
      if (res.status === "0") {
        if (type === 1) {
          this.groupForm.registerRecord = res.data;
          this.loadingRecordImg = false;
          this.$refs.groupForm.clearValidate("registerRecord");
        } else if (type === 2) {
          this.groupForm.studentIDImg = res.data;
          this.loadingIDImg = false;
          this.$refs.groupForm.clearValidate("studentIDImg");
        } else if (type === 3) {
          this.groupForm.photoIDImg = res.data;
          this.loadingPhotoIDImg = false;
          this.$refs.groupForm.clearValidate("photoIDImg");
        }
        if (type === 4) {
          this.groupForm.photo = res.data;
          this.loadingAvatar = false;
        }
        if (type === 5) {
          this.groupForm.groupImg = res.data;
          this.loadingGroupImg = false;
        }
        this.$message.success("Image upload successfully!");
      } else {
        this.$message.error("Image upload failed, please upload again!");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.profile-box {
  height: 100%;
  padding: 12px;
  background: #fff;
  box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  position: relative;
  box-sizing: border-box;
  .profile-box_container {
    margin-top: 20px;
    box-sizing: border-box;
    position: relative;

    .left,
    .right {
    }
    .right {
    }
  }

  /deep/.el-textarea__inner {
    font-family: "PingFangSC-Semibold", "PingFang SC";
  }
  .profile-title {
    height: 25px;
    font-size: 18px;
    font-weight: normal;
    color: #181d2c;
    line-height: 25px;
    text-align: center;
  }

  .profile-avatar-box {
    text-align: center;
    .my-info-avatar {
      width: 96px;
      height: 96px;
      border-radius: 50%;
    }
    .upload-info {
      font-size: 15px;
      color: #f48c06;
      line-height: 20px;
      img {
        vertical-align: top;
      }
    }
  }
  /deep/.el-form-item__label {
    height: 20px;
    font-size: 15px;
    font-weight: normal;
    color: #181d2c;
    line-height: 20px;
    margin-bottom: 8px;
  }
  .profile-item {
    margin-top: 24px;
    .profile-item-content {
      margin-top: 8px;
      .el-textarea {
        font-size: 15px;
        color: #181d2c;
      }
    }
  }
  .inline-upload {
    display: grid;

    grid-template-columns: repeat(2, 1fr);
    grid-gap: 24px;
    .el-form-item {
    }
  }
  .item-upload {
    width: 100%;
    /deep/.el-upload {
      width: 100%;
      height: 144px;
      cursor: pointer;
      color: #b7b2ae;
      font-weight: 600;
      i {
        color: #b7b2ae;
        font-size: 16px;
      }
      span {
        line-height: 20px;
      }
    }
  }
  .my-button {
    border: none;
    background: #f48c06;
    border-radius: 4px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 16px;
  }
  .item-button {
    height: 48px;
    background: #b7b2ae;
    padding: 14px 44px;
    border-radius: 24px;
    color: #ffffff;
    font-weight: 600;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    pointer-events: none;
    span {
      line-height: 20px;
    }
  }

  .el-textarea__inner {
    font-family: "PingFangSC-Semibold", "PingFang SC";
  }
  .upload-icon {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    background-repeat: no-repeat;
    background-position: left center;
    background-size: contain;

    border: 1px solid;
  }
}
</style>
